import React from 'react';
import PropTypes from 'prop-types';
import {useNavigate} from 'react-router-dom';
import {Button} from '@tenancy.nz/ui';

function LinkButton({
  children,
  color,
  disabled,
  onClick,
  to,
  underline,
  state,
  ...rest
}) {
  const navigate = useNavigate();

  const {sx = {}} = rest;

  const styles = {
    ...(!color && {backgroundColor: '#fff !important'}),
    textDecoration: 'none',
    ...(underline === 'always' &&
      !disabled && {textDecoration: 'underline !important'}),
    ...(underline === 'hover' &&
      !disabled && {
        '&:hover': {textDecoration: 'underline'},
      }),
    ...sx,
  };

  const handleClick = e => {
    if (!to && onClick) {
      onClick(e);
      return;
    }
    if (!to) {
      return;
    }
    navigate(to, {
      state: state || {},
    });
  };

  return (
    <Button
      disabled={disabled}
      {...rest}
      color={color}
      onClick={handleClick}
      sx={styles}
      type="button">
      {children}
    </Button>
  );
}

LinkButton.propTypes = {
  children: PropTypes.node.isRequired,
  color: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  state: PropTypes.shape({}),
  to: PropTypes.string,
  underline: PropTypes.oneOf(['always', 'hover', 'none']),
};

LinkButton.defaultProps = {
  color: undefined,
  disabled: false,
  onClick: undefined,
  state: {},
  to: undefined,
  underline: 'none',
};

export default LinkButton;
